import { supabase, getUserRole } from '../config/supabase.js'
import { formatBirthDate, formatDate, extractYear } from '../utils/helpers.js'
import { navigateToPerson } from '../router/router.js'
import { navigateToPersonAdd } from '../router/router.js'
import { searchTree } from '../tree/family-tree.js'
import './person-list.css'

let allPersons = []

export async function loadPersonListData() {
  try {
    // Get statistics
    const { data: persons, error: personError } = await supabase
      .from('person')
      .select('id, is_living')
    
    if (personError) throw personError
    
    const { data: families, error: familyError } = await supabase
      .from('family')
      .select('id', { count: 'exact' })
    
    if (familyError) throw familyError
    
    // Update stats
    document.getElementById('person-count').textContent = persons.length
    document.getElementById('family-count').textContent = families.length
    document.getElementById('living-count').textContent = 
      persons.filter(p => p.is_living).length
    
    // Get full person data
    const { data: fullData, error: fullError } = await supabase
      .from('person')
      .select(`
        *,
        person_name!inner(*),
        event(*)
      `)
    
    if (fullError) throw fullError
    
    // Sort by surname
    fullData.sort((a, b) => {
      const aName = a.person_name.find(n => n.is_primary) || a.person_name[0]
      const bName = b.person_name.find(n => n.is_primary) || b.person_name[0]
      const aSurname = aName?.surname || ''
      const bSurname = bName?.surname || ''
      return aSurname.localeCompare(bSurname)
    })
    
    allPersons = fullData
    displayPersons(allPersons)
    
  } catch (error) {
    console.error('Error loading data:', error)
    document.getElementById('person-grid-container').innerHTML = `
      <div class="error">
        <strong>Error loading data:</strong> ${error.message}
      </div>
    `
  }
}

async function displayPersons(persons) {
  const content = document.getElementById('person-grid-container')
  
  if (persons.length === 0) {
    content.innerHTML = '<div class="loading">No people found</div>'
    return
  }
  
  const userRole = await getUserRole()
  
  const html = persons.map(person => {
    const primaryName = person.person_name.find(n => n.is_primary) || person.person_name[0]
    const birthEvent = person.event.find(e => e.event_type === 'birth')
    const deathEvent = person.event.find(e => e.event_type === 'death')
    
    return `
      <div class="person-card" data-person-id="${person.id}">
        <div class="person-name">
          ${primaryName.full_name}
          <span class="badge ${person.is_living ? 'badge-living' : 'badge-deceased'}">
            ${person.is_living ? 'Living' : 'Deceased'}
          </span>
        </div>
        <div class="person-details">
          ${person.sex ? `<div class="person-detail">Gender: ${person.sex === 'M' ? 'Male' : person.sex === 'F' ? 'Female' : 'Unknown'}</div>` : ''}
          ${birthEvent ? formatBirthDate(birthEvent, person.is_living) : ''}
          ${deathEvent ? `<div class="person-detail">Died: ${formatDate(deathEvent.date_text)}</div>` : ''}
          ${userRole === 'admin' && person.gedcom_xref ? `<div class="person-detail" style="color: #999; font-size: 12px; font-style: italic;">GEDCOM ID: ${person.gedcom_xref}</div>` : ''}
        </div>
      </div>
    `
  }).join('')
  
  content.innerHTML = `<div class="person-grid">${html}</div>`
  
  // Add click handlers
  document.querySelectorAll('.person-card').forEach(card => {
    card.addEventListener('click', () => {
      const personId = card.dataset.personId
      navigateToPerson(personId)
    })
  })
}

export function initPersonList() {
  
  // Add person button handler

  const addBtn = document.getElementById('add-person-btn')
     if (addBtn) {
       addBtn.addEventListener('click', () => {
         navigateToPersonAdd()
       })
     }
  
  // Search functionality
  document.getElementById('search').addEventListener('input', (e) => {
    const searchTerm = e.target.value.toLowerCase()
    
    if (searchTerm === '') {
      displayPersons(allPersons)
      searchTree('')  // ADD THIS - clears tree filter
      return
    }
    
    const filtered = allPersons.filter(person => {
      const names = person.person_name.map(n => 
        `${n.full_name} ${n.given_name} ${n.surname}`.toLowerCase()
      ).join(' ')
      
      return names.includes(searchTerm)
    })
    
    displayPersons(filtered)
    searchTree(searchTerm)  // ADD THIS - filters tree
  })
}

export function showPersonList() {
  document.getElementById('person-detail-page').classList.add('hidden')
  document.getElementById('person-edit-page').classList.add('hidden')
  document.getElementById('person-add-page').classList.add('hidden')
  document.getElementById('password-setup-page').classList.add('hidden')
  document.getElementById('user-profile-page').classList.add('hidden')  // ADD THIS
  document.getElementById('content').classList.remove('hidden')
}